// Карточки последнего замера: оценка, вес, скелетные мышцы, жир % с изменением к предыдущему.

import { Link } from 'react-router-dom'

import { Card, Stat } from '@/components/ui'
import { formatDate, formatNumber, pluralRu } from '@/lib/format'

import type { InBodySummaryOut, ScanField } from '../api'
import { FIELD_LABELS } from '../labels'
import { deltaText, isGood, toneClass } from './deltaFormat'

const CARDS: readonly ScanField[] = ['score', 'weight_kg', 'skeletal_muscle_kg', 'body_fat_pct']

function analysisNote(summary: InBodySummaryOut) {
  const latest = summary.latest
  if (!latest?.analysis) return null
  if (latest.analysis.status === 'ok') {
    return (
      <Link to={`/health/inbody/${latest.id}`} className="text-sm font-medium text-accent hover:underline">
        Разбор ИИ последнего замера
      </Link>
    )
  }
  if (latest.analysis.status === 'pending') return <span className="text-sm text-muted">Разбор ИИ готовится</span>
  return null
}

function sinceText(days: number | null): string | undefined {
  if (days === null) return undefined
  if (days === 0) return 'Сегодня'
  return `${days} ${pluralRu(days, ['день', 'дня', 'дней'])} назад`
}

export function StatCards({ summary }: { summary: InBodySummaryOut }) {
  const latest = summary.latest
  if (!latest) return null
  return (
    <Card
      data-testid="stat-cards"
      title={
        <Link to={`/health/inbody/${latest.id}`} className="hover:underline">
          Замер за {formatDate(latest.day)}
        </Link>
      }
      subtitle={sinceText(summary.days_since_last)}
      actions={analysisNote(summary)}
    >
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {CARDS.map((field) => {
          const meta = FIELD_LABELS[field]
          const row = summary.comparison.find((r) => r.field === field)
          const delta = row?.delta_previous ?? null
          return (
            <Stat
              key={field}
              label={meta.label}
              value={formatNumber(latest[field] ?? null, { digits: meta.digits })}
              unit={meta.unit}
              hint={
                row && delta !== null ? (
                  <span className={toneClass(isGood(delta, row.better))}>{`${deltaText(delta, row)} к предыдущему`}</span>
                ) : null
              }
            />
          )
        })}
      </div>
    </Card>
  )
}
